import React, { useState, useEffect } from "react";
import axios from "axios";
import { App, Card, Input, Button, Typography } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone, ArrowLeftOutlined } from "@ant-design/icons";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./ResetPassPage.css";

const { Title, Text } = Typography;

const ResetPasswordPage = () => {
  const { message, notification } = App.useApp();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token || !email) {
      notification.error({
        message: "Invalid password reset link",
        description: "Please request a new password reset.",
      });
      navigate("/login");
    }
  }, [token, email, navigate, notification]);

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      return message.warning("Please fill all fields");
    }

    if (newPassword.length < 6) {
      return message.warning("Password must be at least 6 characters");
    }

    if (newPassword !== confirmPassword) {
      return message.warning("Passwords do not match");
    }

    setLoading(true);

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Auth/reset-password`,
        {
          Email: email,
          Token: token,
          NewPassword: newPassword,
        }
      );

      message.success("Password reset successfully. Please login.");
      navigate("/login");
  
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Invalid or expired reset link.";
      notification.error({ message: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-container">
      <Card className="reset-card">
        <Button
          type="link"
          size="large"
          onClick={() => navigate('/login')}
          style={{
            padding: 0,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            color: 'black'
          }}
        >
          <ArrowLeftOutlined />
        </Button>
        <div className="logo-container">
          <img src={require("../../assets/logo.png")} alt="logo" />
        </div>

        <Title level={3}>Reset Password</Title>
        <Text type="secondary">
          Set a new password for <strong>{email}</strong>
        </Text>

        <div className="form-item">
          <Text strong>New Password</Text>
          <Input.Password
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </div>

        <div className="form-item">
          <Text strong>Confirm Password</Text>
          <Input.Password
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </div>

        <Button
          type="primary"
          block
          className="reset-button"
          loading={loading}
          onClick={handleResetPassword}
        >
          Reset Password
        </Button>
      </Card>
    </div>
  );
};

export default ResetPasswordPage;
